import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Narrative from "./components/Narrative";
import LiveChart from "./components/LiveChart";
import Tokenomics from "./components/Tokenomics";
import Leaderboard from "./components/Leaderboard";
import HowToBuy from "./components/HowToBuy";
import Community from "./components/Community";
import MemeWall from "./components/MemeWall";
import AuthModal from "./components/AuthModal";
import AuthProvider from "./context/AuthContext";
import CaFooter from "./components/CaFooter";
import Intro from "./components/Intro";
import { INTRO_MS } from "./lib/constants";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ocean-bg p-8">
          <p className="font-display text-2xl text-ocean-navy">
            The whale hit an iceberg. Refresh to surface again.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  const lenisRef = useRef(null);
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const timer = setTimeout(() => setIntroDone(true), INTRO_MS);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      clearTimeout(timer);
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) lenisRef.current?.scrollTo(el, { offset: -90, duration: 1.4 });
  };

  return (
    <ErrorBoundary>
      <AuthProvider>
      <div className="relative min-h-screen bg-ocean-bg text-ocean-navy">
        <Toaster
          data-testid="toast-container"
          position="top-center"
          toastOptions={{
            style: {
              border: "3px solid #0F172A",
              boxShadow: "4px 4px 0 0 #0F172A",
              borderRadius: "1rem",
              background: "#FFFFFF",
              color: "#0F172A",
              fontFamily: "Fredoka, sans-serif",
              fontWeight: 600,
            },
          }}
        />
        <div className="noise-overlay" aria-hidden="true" />
        <AnimatePresence>{!introDone && <Intro />}</AnimatePresence>
        <AnimatePresence>
          {introDone && (
            <motion.div
              key="site"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Navbar onNav={scrollTo} />
              <main>
                <Hero onNav={scrollTo} />
                <Marquee />
                <Narrative />
                <LiveChart />
                <Tokenomics />
                <Leaderboard />
                <HowToBuy onNav={scrollTo} />
                <Community />
                <MemeWall />
              </main>
              <CaFooter onNav={scrollTo} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <AuthModal />
      </AuthProvider>
    </ErrorBoundary>
  );
}
